import { useAppSelector } from '../../../../stores/redux.store';

export const useWelcomeState = () => {
  const email = useAppSelector(state => state.welcome.email);
  const displayName = useAppSelector(state => state.welcome.displayName);

  return {
    displayName,
    email,
  };
};
